export default __webpack_public_path__ + "static/media/somerset-logo.35728196.png";